import { RouteConfig } from 'vue-router';

import { redirectSignedInUser } from '@/utils/redirectSignedInUser';
import { confirmRoute } from './start/confirm.route';
import { loginRoute } from './start/login.route';
import { registerRoute } from './start/register.route';
import { resendConfirmRoute } from './start/resend.route';
import { resetFormRoute } from './start/resetPassword.route';

export const startRoute: RouteConfig = {
  path: '/',
  component: () => import(/* webpackChunkName: "StartLayout" */ '@/components/Router.vue'),
  children: [loginRoute, registerRoute, confirmRoute, resendConfirmRoute, resetFormRoute],
  redirect: { name: 'login' },
  beforeEnter: (to, from, next) => redirectSignedInUser(next)
};
